import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseListView } from '../../../../icemedx-lib/src/components/baseview.component';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { iceColumnDefinition, IcecontrolPermission, IcecontrolSettings, IcepanelcontainerSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { paytoindex } from '../../../../icemedx-lib/src/models/accounting/paytoindex';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { AppService } from '../app.service';
import { BreadcrumType } from '../../../../icemedx-lib/src/services/baseapp.service';
import { BreadcrumbService } from '../../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-paytohistory',
  templateUrl: './paytohistory.component.html',
  styleUrls: ['./paytohistory.component.scss'],
  providers: [AppService, IceNavService]
})
export class PaytohistoryComponent extends BaseListView {

  // member settings
  payToViewSettings: IcepanelcontainerSettings = null;
  payToPermission: IcecontrolPermission = null;


  constructor(appSvc: AppService,
    navSvc: IceNavService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    private breadcrumbService: BreadcrumbService,
    loginSvc: LoginService,
    router: Router) {

    super(appSvc, loginSvc, navSvc, router);

    appSvc.defaultMenus();
    this.addBreadcrumbs();

    let feaAccess = appSvc.getPermission(userTypes.USER_FEATURES.ufAccountingJournals).default_access;
    this.payToPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufAccountingJournals, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.setInlineEditing(true);
    this.payToViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufAccountingJournals);
    this.accSvc.getPayToHistory(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), "").subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.refreshTableData([]);
          return;
        }

        let receipts: paytoindex[] = <paytoindex[]>data;

        let datasrc = [];
        for (let i = 0; i < receipts.length; i++) {
          let tempidx: paytoindex = receipts[i];
          if (tempidx == null) continue;

          let createdate = Iceutility.isTextDateTime(tempidx.created) ? Iceutility.getDateTextEx(tempidx.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.created));
          let modifieddate = Iceutility.isTextDateTime(tempidx.modified) ? Iceutility.getDateTextEx(tempidx.modified) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.modified));
          tempidx.created = createdate;
          tempidx.modified = modifieddate;
          tempidx["to_account_type_text"] = DomainService.getDomainType(Iceutility.toLong(tempidx.to_account_type));
          tempidx["pay_status_text"] = MessageService.getStatus(Iceutility.toLong(tempidx.pay_status), IceTypes.SourceType.srcStatement);
          datasrc.push(tempidx);
        }

        this.refreshTableData(data);
      }, error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(domainSvc.getLastErrors()));
      });
  }

  addBreadcrumbs() {
    this.breadcrumbService.updateBreadcrumbs({
      TREE: { display: "Accounting", data: null, active: false, link: "/accounting/summary", history: [] },
      BRANCH: { display: "Pay To History", data: null, active: true, link: "", history: [] }
    }, BreadcrumType.btYard.toString());
  }

  getBreadcrumbs(): any {
    return this.getAppService().getBreadcrumbs();
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [
      new iceColumnDefinition("pay_to", "Pay to", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("pay_to_name", "Network ID", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("to_account_type_text", "Type", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("pay_status_text", "Status", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("created", "Created Date", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("modified", "Mod. Date", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("QuickActions", "", false, false),
      new iceColumnDefinition("pay_to_index_key", "pay_to_index_key", false, true),
      new iceColumnDefinition("pay_to_key", "pay_to_key", true),
    ];
  }

  onGetActionItems(): any[] {
    return [IceTypes.recordQuickActionEdit,
    IceTypes.recordQuickActionView,
    IceTypes.recordQuickActionRemove];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  /////////////////////////////////////
  // Events

  onButtonClick(event) {
    /*
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        case BillingActionDomainItemSubmit: {
          let itemEntryFrm = this.ctrlBillingDomainItemEntryCtrl.getFormControl();
          if (itemEntryFrm != null)
            this.processItemEntry(itemEntryFrm.value, "");
          break;
        }
        default: {
          // Add New Item to DB
          if (this.appSvc.processEditPanelSectionButtons(this.sectionTagNewItem, event.buttonSettings.id)) {
            let item: otheritems = new otheritems(this.newItem);
            if (this.newItem != null && this.newItem["code_object"] != null && this.newItem["code_object"].length > 0) {
              try {
                let codeObj = JSON.parse(this.newItem["code_object"]);
                if (codeObj != null && codeObj.length > 0) {
                  this.newItem.code = item.code = codeObj[0].value;
                  this.newItem.code_txt = item.code_txt = codeObj[0].name;

                }
              }
              catch (e) {
                console.log(e);
              }
            }

            let codeQuaList = MedicalcodesService.getMedicalCodeTypeList().filter(opt => item.code_list_qualifier_code == opt.name);
            if (codeQuaList.length > 0) {
              item.code_list_qualifier_code = codeQuaList[0].value;
            }

            let unitList = this.invUnitCtrl.getOptions().filter(opt => item.unit_type == opt.name);
            if (unitList.length > 0) {
              item.unit_type = unitList[0].value;
            }

            this.accSvc.addOtherItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), item).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                if (this.newItem == null) return;

                if (this.resultsDataSource.data == null) this.resultsDataSource.data = [];

                let svrItem: otheritems = <otheritems>data[0];
                if (svrItem == null) return;

                this.newItem.other_items_key = svrItem.other_items_key;
                this.resultsDataSource.data.push(this.newItem)
                this.resultsDataSource.data = this.resultsDataSource.data;

                // Reset;
                this.newItem = null;
              },
              error => {
                // To do, log error
              });            
          }
          break;
        }
      }
    }
    */
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case "PayToTable": {
          //this.getRouter().navigate([this.getNavService().buildRoute("accounting/statement/0", false)]);
          break;
        }
      }
    }
  }

  onMatGridRowClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    if (IceTypes.RecordActionType.oatView == event.actionItem.value) {
      let item = <paytoindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      //this.getRouter().navigate([this.getNavService().buildRoute("accounting/outstandingbalance/" + item.superbill_charges_key, false)]);
    }
    else if (IceTypes.RecordActionType.oatEdit == event.actionItem.value) {
      let item = <paytoindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      //this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/" + item.superbill_charges_key, false)]);
    }
    else if (IceTypes.RecordActionType.oatRemove == event.actionItem.value) {
      let item = <paytoindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
    //  this.accSvc.deleteBill(this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), item.superbill_charges_key).subscribe(
    //    data => {
    //      let dataSrc = this.getDataSource();
    //      dataSrc.data = dataSrc.data.filter(b => b.superbill_charges_key != item.superbill_charges_key);
    //    },
    //    error => {
    //      // To do, log error
    //    });
    }
  }
}
